module.exports = __webpack_public_path__ + "img/foot-tel.9d8f19b7.png";